module.exports = __webpack_public_path__ + "img/cta-bg.694f94ff.jpg";